<template>
  <modal-layout :is-open="isOpen" @close="modalClose">
    <div class="Modal_area Explanation__modal_area">
      <div class="Modal__cross-box _cross" @click="modalClose">
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner Explanation__modal_inner Explanation__modal_inner--pd_lr">
        <div class="Explanation__class">
          <ul class="Explanation__class_list">
            <li
              v-for="program in listPrograms"
              v-show="program.display_status == 1"
              :key="program.id"
              class="Explanation__class_list_item"
            >
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" :src="`${program.image_url}`">
                <span style="text-transform:capitalize;">{{ program.name }}</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" :src="`${program.icon_url}`">
                <!-- eslint-disable vue/no-v-html -->
                <p v-html="program.description" />
                <!--eslint-enable-->
                <div class="Explanation__class_list_check">
                  <label
                    class="Check__box Check__box--center Check__box__lightblue _ft-spacing60"
                  >
                    <input
                      v-model="program.is_favorite_user"
                      type="checkbox"
                      name="favorite-class"
                      @click="change(program.id)"
                    >
                    <span class="Check__box_inner" />
                    <span class="Check__box_inner_tx">お気に入り登録</span>
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </modal-layout>
</template>
<script>
import ModalLayout from '@/views/components/modals/ModalLayout.vue'
import programcategoryService from '@/services/programcategoryService'
export default {
  name: 'ClassFavoriteList',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listPrograms: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getListPrograms()
    },
    async getListPrograms() {
      const response = await programcategoryService.index()
      this.listPrograms = response.data
    },
    modalClose() {
      this.$emit('close')
    },
    change(id) {
      this.$emit('changeCategory', id)
    }
  }
}
</script>
